<script>
  // Перенос Photo из parts.tsx — картинка с цепочкой источников: пробуем по
  // очереди, на ошибке переходим к следующему, в конце — иконка-заглушка.
  import Ico from './ico.svelte';

  export let src = '';
  export let alt = '';
  export let cls = '';
  export let icon = 'photo';

  $: list = (Array.isArray(src) ? src : [src]).filter(Boolean);
  let i = 0;
  let _key = '';
  $: { const k = list.join('|'); if (k !== _key) { _key = k; i = 0; } }
  $: url = list[i];
</script>

<div class={'mn-shot ' + (cls || '')}>
  {#if url}
    <img src={url} alt={alt || ''} on:error={() => { i += 1; }} />
  {:else}
    <Ico n={icon} s={26} class="ph" />
  {/if}
</div>
